export default __webpack_public_path__ + "austin_sites_fe.9a1a2fca.csv";